module.exports = __webpack_public_path__ + "img/ALSH_SEJOUR_MERCREDI.b19dd29a.svg";